const ITEMS = [
  "EXTEND PLAYABLE HOURS",
  "NIGHT GOLF",
  "EVENING EVENTS",
  "DRIVING RANGES",
  "SPORTS FACILITIES",
  "COMMERCIAL OUTDOOR",
  "BEYOND DAYLIGHT",
];

export default function Marquee() {
  const row = (
    <div className="flex items-center shrink-0">
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="font-display text-sm sm:text-base font-semibold tracking-[0.3em] text-white/35 px-8 whitespace-nowrap">
            {item}
          </span>
          <span className="w-1.5 h-1.5 rounded-full bg-[#326B46]" />
        </span>
      ))}
    </div>
  );
  return (
    <div className="border-y hairline bg-[#0B0D0C] py-6 overflow-hidden" data-testid="editorial-marquee" aria-hidden="true">
      <div className="marquee-track">
        {row}
        {row}
      </div>
    </div>
  );
}
